export default __webpack_public_path__ + "static/media/Vacuum-Cleaners-mob.c7862a05.jpg";